































































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import SwiperNews from "@/zh-website/src/components/website/Swiper/SwiperNews.vue";
import SwiperCase from "@/zh-website/src/components/website/Swiper/SwiperCase.vue";
import SideBar from "@/zh-website/src/components/website/SideBar.vue";
import Dynamic from "@/zh-website/src/components/website/Dynamic.vue";
// 引入背景组件
import Banner from "@/zh-website/src/components/website/Swiper/Banner.vue";
import { NewsService } from "@/zh-website/src/views/Content/service/newsService";
import { CollegesService } from "@/zh-website/src/views/Colleges/service";
@Component({
  components: {
    SideBar,
    Swiper,
    SwiperSlide,
    SwiperNews,
    Banner,
    Dynamic,
    SwiperCase
  }
})
export default class ProductIndex extends Vue {
  dynamicList: any = {
    title: "合作动态",
    list: []
  };
  // 轮播图配置
  SwiperConfig = {
    slidesPerView: 5,
    spaceBetween: -10,
    centeredSlides: true,
    loop: true,
    observer: true,
    observerParents: true,
    slideToClickedSlide: true,
    preventClicks: true,
    grabCursor: true,
    autoplay: {
      delay: 3000, //1秒切换一次
      disableOnInteraction: false
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  };
  // 背景图样式文案
  list = {
    style: {
      "background-image": `url(${require("../../assets/banner+TOP.png")})`,
      height: "493px"
    },
    font1: "高校ICT人才培养",
    font2: "产教融合 数字使能 智联未来",
    font3: "",
    button: ""
  };
  intList: any[] = [];
  /* intList = [
     {
      src: require("../../assets/intoft_1.png"),
      name: "物联网专业",
      text1: "多视角、全维度",
      text2: "培养互联生态物联人才",
      link: "/colleges/solve/profession/network"
    },
    {
      src: require("../../assets/intoft_2.png"),
      name: "大数据专业",
      text1: "全方位、深层次",
      text2: "培养大数据未来人才",
      link: "/colleges/solve/profession/bigdata"
    },
    {
      src: require("../../assets/intoft_3.png"),
      name: "云计算专业",
      text1: "一云两翼双引擎",
      text2: "培养混合云下的复合型云计算人才",
      link: "/colleges/solve/profession/cloud"
    },
    {
      src: require("../../assets/intoft_4.png"),
      name: "人工智能专业",
      text1: "全场景、端到端",
      text2: "培养智能时代智慧人才",
      link: "/colleges/solve/profession/ideas"
    },
    {
      src: require("../../assets/intoft_5.png"),
      name: "移动通信专业",
      text1: "新空口、新架构",
      text2: "培养移动通信核心人才",
      link: "/colleges/solve/profession/communication"
    }
  ];*/
  caseList: any[] = [];
  caseJump = "";
  newjump = "/home/news/det/";
  rightNew: any = [];
  leftNew: any = {};

  mounted() {
    this.getCase();
    this.getMajorList();
    this._getRightNew();
  }

  // 获取院校成功案例
  async getCase() {
    //调用接口获取院校成功案例
    CollegesService.getProductCaseList({}).then((res: any) => {
      res.data.list.sort((a, b) => a.sort - b.sort);
      res.data.list.forEach((item: any, index: number) => {
        this.caseList.push({
          dictName: item.title,
          id: "caseDetail/" + item.id,
          field1: item.intro,
          field3: `background-image:url("${item.coverResourceUrl}")`,
          sort: item.sort
        });
      });
    });
  }
  getMajorList() {
    CollegesService.getProductSolutionList({}).then((res: any) => {
      //
      //this.intList = res.data.list;
      res.data.list.forEach(item => {
        this.intList.push({
          src: item.resourceUrl,
          name: item.name,
          text1: item.intro,
          text2: "培养移动通信核心人才",
          link: `/colleges/solve/profession/${item.id}`
        });
      });
    });
  }
  //右侧新闻动态
  async _getRightNew() {
    NewsService.getNewsList({ pageNum: 1, pageSize: 5, timeFrameCode: 1 }).then(
      (res: any) => {
        if (res.data.list.length > 0) {
          this.leftNew = res.data.list[0];
          this.rightNew = res.data.list.slice(1, res.data.list.length);
        } else {
          this.leftNew = {};
          this.rightNew = [];
        }
      }
    );
  }
}
